import React from "react";
import { TurnrTableCell } from "../TurnrTableSmart.jsx";
import TurnrOrderLink from "../../links/TurnrOrderLink.jsx";
import { getForeignOrderId } from "~/cores/orderCore";

export function getTableHeadOrderId({ ...rest } = {}) {
    return {
        id: "order.foreignNumber",
        label: "Order Id",
        sortable: false,
        ...rest,
    };
}

export function TableCellOrderId({ order, foreignOrderId = getForeignOrderId(order), includeForeignOrderId = true, highlightText, ...rest }) {
    return (
        <TurnrTableCell {...rest}>
            <TurnrOrderLink order={order} foreignOrderId={foreignOrderId} includeForeignOrderId={includeForeignOrderId} highlightText={highlightText} />
        </TurnrTableCell>
    );
}
